<template>
    <div>
        <div class="ui-comments-header mt-5 mb-4">{{ $t('online_lessons_reviews') }}</div>
        <ul
                class="ui-comments mt-5"
                v-if="comments.length"
        >
            <li
                    class="ui-comments__item"
                    :key="comment.id"
                    v-for="comment in comments"
            >
                <UiComment
                        :avatar="getAvatar(comment)"
                        :name="getName(comment)"
                        :content="comment.content"
                        :created="comment.created"
                        :link="comment.link"
                >
                    <template v-slot:avatar>
                        <UiAvatar size="132">
                            <img
                                    :src="comment.avatar"
                                    v-if="comment.avatar"
                            >
                            <UiAvatarPlaceholder
                                    size="132"
                                    v-else
                            />
                        </UiAvatar>
                    </template>
                </UiComment>
            </li>
        </ul>

        <p v-else>
            {{ $t('online_lessons_reviews_empty') }}
        </p>

        <div
                class="ui-comment-notify"
                v-if="isCreated"
        >
            <i class="ui-comment-notify__icon fa fa-check-circle"></i>
            <div class="ui-comment-notify__description">
                <strong>{{ $t('online_lessons_thanks') }}</strong><br>
                {{ $t('online_lessons_moderate_notice') }}
            </div>
        </div>

        <form
                v-else
                class="ui-comment-form"
                @submit.prevent="createComment"
        >
            <div class="d-flex justify-content-center mb-3">
        <textarea
                required
                rows="5"
                class="ui-comment-form__input flex-grow-1"
                :placeholder="$t('online_lessons_review_placeholder')"
                v-model="comment"
        ></textarea>
            </div>
            <button class="btn btn-info ui-btn ui-btn--info" type="submit">
                {{ $t('review_post') }}
            </button>
        </form>
    </div>
</template>

<script>
    import courseApi from '@/data/CourseApi';

    import UiComment from '@/components/UiComment';
    import UiAvatar from '@/components/UiAvatar';
    import UiAvatarPlaceholder from '@/components/UiAvatarPlaceholder';

    export default {
        name: 'CourseComments',

        props: {
            course: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                comments: [],
                comment: null,
                isCreated: false,
            }
        },

        created() {
            this.fetchComments();
        },

        methods: {
            fetchComments() {
                courseApi.fetchComments(this.course.idcourse)
                    .then(comments => {
                        this.comments = comments;
                    });
            },

            createComment() {
                courseApi.createComment(this.course.idcourse, this.comment)
                    .then(() => {
                        this.isCreated = true;
                        this.comment = null;
                    })
            },

            getAvatar(comment) {
                if (comment.profile && comment.profile.avatar) return comment.profile.avatar
                return comment.avatar
            },

            getName(comment) {
                if (comment.profile && comment.profile.name) return comment.profile.name
                return comment.user_name
            }
        },

        components: {
            UiComment,
            UiAvatar,
            UiAvatarPlaceholder,
        }
    }
</script>

<style>

    @media (max-width: 991.8px) {
        .ui-comments-header, .ui-comments, .ui-comment-form {
            margin-left: 15px !important;
            margin-right: 15px !important;
        }
    }

    .ui-comments-header {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #231c37;
    }

    .ui-comments {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .ui-comments__item {
        margin-bottom: 40px;
    }

    .ui-comment-form {
        max-width: 600px;
        margin: 0 auto 100px;
        text-align: center;
    }

    .ui-comment-form__input {
        padding: 5px 10px;
    }

    .ui-comment-notify {
        background-color: rgba(0, 0, 0, .05);
        border-radius: 20px;
        margin: 0 auto 100px;
        max-width: 600px;
        padding: 20px;
        text-align: center;
    }

    .ui-comment-notify__icon {
        color: #58B946;
        font-size: 4rem;
        margin-bottom: 20px;
    }
</style>
